import React from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Field } from 'react-final-form';
import Stack from '@mui/material/Stack';
import ToggleButtonGroup from 'components/ToggleButtonGroup';
import DateTimeComboField from 'components/DateTime/DateTimeComboField';
import moment from 'moment';
import FormSection from 'components/Layout/FormSection';
import { CardConfigurerStepProps } from '../CardConfigurerForm';
import MultiCardDisplay from './stepComponents/MultiCardDisplay';
import { isCardDotGiftCard } from '../configurerFlags';
import PanelLayout from './stepComponents/PanelLayout';
// import debug from 'debug';
// const d = debug('cardDelivery');

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      '&[hidden]': {
        display: 'none',
      },
    },
  }),
  { name: 'CardDelivery' },
);

const CardDelivery: React.FC<CardConfigurerStepProps> = ({ step, index, values, product, submitButton }) => {
  const classes = useStyles();
  const minDeliveryTime = moment().add(15, 'minutes').utc();

  const validateDeliveryTime = (value: any) => {
    return moment(value).isSameOrAfter(minDeliveryTime) ? undefined : 'error';
  };

  const title = 'When would you like to send your gift?';

  const cardImageContent = <MultiCardDisplay defaultProductHandle={product.handle} values={values} showLogo={!!values.cardCustomImage && !isCardDotGiftCard(product)} />;

  const formContent = (
    <Stack spacing={4}>
      <FormSection sx={{ alignItems: { xs: 'center', md: 'flex-start' } }}>
        <Field name="deliveryType" defaultValue="now">
          {({ input: { value, onChange } }) => (
            <ToggleButtonGroup
              fullWidth={false}
              name="deliveryType"
              items={[
                {
                  label: 'Send Now',
                  value: 'now',
                },
                {
                  label: 'Schedule Send',
                  value: 'scheduled',
                },
              ]}
              value={value}
              onChange={(event, newValue) => {
                newValue ? onChange(newValue) : onChange(value);
              }}
            />
          )}
        </Field>
        {values.deliveryType === 'scheduled' && (
          <Field name="deliveryTime" validate={validateDeliveryTime}>
            {({ input: { value, onChange } }) => (
              <DateTimeComboField
                value={value}
                onChange={(newValue) => {
                  onChange(newValue);
                }}
              />
            )}
          </Field>
        )}
      </FormSection>
    </Stack>
  );

  return (
    <div className={classes.root} hidden={step !== index}>
      <PanelLayout value={step} index={index} title={title} cardImageContent={cardImageContent} formContent={formContent} buttonsContent={submitButton} />
    </div>
  );
};

export default CardDelivery;
